import { handleActions } from '@gef-ui/utils/fsaActions';
import mergeRight from "ramda/es/mergeRight";
import mergeWithDotPath from "ramda-extension/es/mergeWithDotPath";
import { codelistActionTypes, codelistLoadingStates } from '../../constants';
const register = {
    next (state, action) {
        const { codelistStoreKey } = action.payload;
        if (!state[codelistStoreKey]) {
            return mergeWithDotPath(codelistStoreKey, mergeRight, {
                values: null,
                loading: codelistLoadingStates.REGISTERED
            }, state);
        } else {
            return state;
        }
    }
};
const request = {
    next (state, action) {
        const { codelistStoreKey, filter, keepData } = action.payload;
        const values = keepData && state[codelistStoreKey] ? state[codelistStoreKey].values : null;
        return mergeWithDotPath(codelistStoreKey, mergeRight, {
            values,
            filter,
            loading: codelistLoadingStates.LOADING
        }, state);
    }
};
const success = {
    next (state, action) {
        const { codelistStoreKey, codelistData } = action.payload;
        return mergeWithDotPath(codelistStoreKey, mergeRight, {
            values: codelistData,
            loading: codelistLoadingStates.SUCCESS
        }, state);
    }
};
const error = {
    next (state, action) {
        const { codelistStoreKey } = action.payload;
        return mergeWithDotPath(codelistStoreKey, mergeRight, {
            values: null,
            loading: codelistLoadingStates.FAIL
        }, state);
    }
};
const clear = {
    next (state, action) {
        const { codelistStoreKey } = action.payload;
        return Object.assign({}, state, {
            [codelistStoreKey]: {}
        });
    }
};
const codelistReducers = {
    [codelistActionTypes.CODELIST_LOAD_DATA_REGISTER]: register,
    [codelistActionTypes.CODELIST_LOAD_DATA_REQUEST]: request,
    [codelistActionTypes.CODELIST_LOAD_DATA_SUCCESS]: success,
    [codelistActionTypes.CODELIST_LOAD_DATA_FAIL]: error,
    [codelistActionTypes.CODELIST_DATA_CLEAR]: clear
};
export default handleActions(codelistReducers, {});
